module.exports = function() {
  return new Worker(__webpack_public_path__ + "31f002ce8ab7835916ac.worker.js");
};